//sendEvent
// 电梯导航

var floorRecommend = function (con, text) {
    con.live('click', 'a', function () {
        var classid = $(this).data('id');
        ht.sendCustomEvent("homePage_liftButton", { button_name: text, "link": classid });
    });
};

var floorAd = function (floor, floorName, num) {
    if (!floor.hasClass('topic')) {
        floor.on('click', 'a', function (e) {
            if (!$(this).find('.title').length) {
                var alt = $(this).find('img').attr('alt'),
                    text = $(this).text(),
                    val = !!alt ? alt : text;
                //楼层的底部banner 
                if ($(e.target).attr('width') == '640') {
                    val = '底部bannner';
                }
                ht.sendCustomEvent("homePage_floor" + num, { button_name: floorName + '——' + val });
            }
        });
    }
};

$(function () {

    //设备切换;
    $('.device').on('click', 'a', function () {
        var index = $(this).index(),
            typeTxt = '';

        switch (index) {
            case 0:
                typeTxt = "APP下载";
                break;

            case 1:
                typeTxt = "触屏版";
                break;

            case 2:
                typeTxt = "电脑版";
                break;
        }

        ht.sendCustomEvent("xkzx_cp_dbqh_v1", { type: typeTxt });
    })
    //header打点


    $('.entry').on('click', 'a', function () {
        var index = $(this).index(),
            typeTxt = '';

        switch (index) {
            case 0:
                typeTxt = "英语";
                break;

            case 1:
                typeTxt = "日语";
                break;

            case 2:
                typeTxt = "英语口语";
                break;

            case 3:
                typeTxt = "小语种";
                break;

            case 4:
                typeTxt = "托福/雅思";
                break;

            case 5:
                typeTxt = "职场/兴趣";
                break;

            case 6:
                typeTxt = "中小幼";
                break;

            case 7:
                typeTxt = "全部分类";
                break;

        }

        ht.sendCustomEvent("homePage_8icon", { category_name: typeTxt });
    });

    $('.loadApp').on('click', '.btn', function () {
        ht.sendCustomEvent("xkzx_cp_yyxz_v1");
    });



    $('section.topic').on('click', 'a.inlineBox', function () {
        var index = $(this).index() + 1;

        // switch (index) {
        //     case 0:
        //         typeTxt = "逢考包过";
        //         break;

        //     case 1:
        //         typeTxt = "玩转口语";
        //         break;

        //     case 2:
        //         typeTxt = "会计入门";
        //         break;

        //     case 3:
        //         typeTxt = "内外兼修";
        //         break;

        // }

        ht.sendCustomEvent("homePage_4recommendations", { index: index });
    });

    $('.floor-text').on('click', 'a', function () {
        var index = $(this).index(),
            typeTxt = '';

        switch (index) {
            case 0:
                typeTxt = "沪江微课";
                break;
            case 1:
                typeTxt = "旅游日语";
                break;
            case 3:
                typeTxt = "1v1评测";
                break;
            case 4:
                typeTxt = "沪江微课";
                break;
        }

        ht.sendCustomEvent("xkzx_cp_hjrd_v1", { type: typeTxt });
    });

    floorAd($('.english'), '英语', 1);
    floorAd($('.japanese'), '日语', 2);
    floorAd($('.moreclass'), '小语种', 3);
    floorAd($('.abroad'), '出国留学', 5);
    floorAd($('.child'), '中小幼', 4);
    floorAd($('.banking'), '财会金融', 6);
    floorAd($('.interest'), '职场兴趣', 7);
    floorAd($('.pubmed'), '考研', 8);

    floorRecommend($('.english .scroll'), '英语');
    floorRecommend($('.japanese .scroll'), '日语');
    floorRecommend($('.moreclass .scroll'), '出国留学');
    floorRecommend($('.abroad .scroll'), '小语种');
    floorRecommend($('.child .scroll'), '中小幼');
    floorRecommend($('.banking .scroll'), '财会金融');
    floorRecommend($('.interest .scroll'), '职场兴趣');
    floorRecommend($('.pubmed .scroll'), '考研');

    $('.special').on('click', 'a', function () {
        var text = $(this).find('p').text();
        ht.sendCustomEvent("xkzx_cp_wyts_v1", { type: text });
    });

    $('.maybeLike').on('click', 'a', function () {
        var classid = $(this).data('id');
        ht.sendCustomEvent("xkzx_cp_kctj_v1", { type: "智能推荐", "link": classid });
    });

    $('.reglog').on('click', 'a', function () {
        var index = $(this).index();
        switch (index) {
            case 0:
                ht.sendCustomEvent("xkzx_cp_kctj_v1", { type: "xkzx_cp_yhdl" });
                break;

            case 1:
                ht.sendCustomEvent("xkzx_cp_kctj_v1", { type: "xkzx_cp_yhzc" });
                break;
        }

    });

    //首页轮播打点
    $('.tempWrap img').live('click', function () {
        ht.sendCustomEvent('homePage_banner');
    })

    //首页底部浮层
    $('.activity-overlay').on('click', 'a', function () {
        var link = $(this).attr('href');
        ht.sendCustomEvent("xkzx_cp_dbfc_v1", { type: link });
    });

    //A6广告打点,大促banner
    $("#a6_adspace_661").on('click', function () {
        ht.sendCustomEvent("homePage_mobileCheer", { type: $(this).attr('id') });
    });

    //电梯导航打点
    $("#courseFloorNav a").live("click", function () {
        ht.sendCustomEvent("homePage_liftButton", { button_name: $(this).text() });
    });

    //给楼层绑定打点事件
    for (var i = 0; i < $(".floor-visible").length; i++) {
        $(window).on('scroll', traceFloor($(".floor-visible").eq(i).attr('id')));
    }

    function traceFloor(floorId) {
        var $floor = $("#" + floorId);
        var bindFunc = function () {
            var scrollTop = document.body.scrollTop,
                floorTop = $floor.offset().top,
                floorHeight = $floor.height(),
                wHeight = $(window).height();

            if (floorId == "special" && scrollTop > floorTop + floorHeight - wHeight) {
                ht.sendCustomEvent("xkzx_impression_v1", { type: floorId });
                $(window).off('scroll', bindFunc);
                return;
            }

            if (scrollTop > floorTop - 90 && scrollTop < floorTop + floorHeight - 90) {
                ht.sendCustomEvent("xkzx_impression_v1", { type: floorId });
                $(window).off('scroll', bindFunc);
            }
        };
        return bindFunc;
    }
    // 阻止默认事件跳转-
    $('body').on('click', 'a', function (event) {
        var _href = $(this).attr('href');
        var _targ = $(this).attr('target');
        // 存在href && 不存在 target && href是有效的链接-
        if (_href && !_targ && !/^(#|java)/i.test(_href)) {
            setTimeout(function () {
                location.href = _href;
            }, 200);
            event.preventDefault();
        }
    });
})



//////////////////
// WEBPACK FOOTER
// ./app/newIndex/js/sendEvent.js
// module id = 38
// module chunks = 0